export const INFORMATION_TABS = {
  COMPANY_INFORMATION: "companyInformation",
  USERS: "users",
  INVOICE_HISTORY: "invoiceHistory",
  CREDIT_NOTE: "creditNote"
} as const;

export const informationTabs = [INFORMATION_TABS.COMPANY_INFORMATION, INFORMATION_TABS.USERS, INFORMATION_TABS.INVOICE_HISTORY, INFORMATION_TABS.CREDIT_NOTE] as const;

export type InformationTabsValue = (typeof informationTabs)[number];

export type PATH_PARAMS = { currentTab: (typeof INFORMATION_TABS)[keyof typeof INFORMATION_TABS] };
